/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnyMemberIsObject, AnyObject } from 'types/general';

const INDEX_OFFSET = 1;

export function sumUp<Item extends number | AnyObject>(
  list: Item[],
  ...config: AnyMemberIsObject<Item> extends never ? [] : [keyof Exclude<Item, number>]
): number {
  let total = 0;

  const [refProp] = config;

  list.forEach((item) => {
    const value = typeof item === 'number' ? item : Number(item[refProp as keyof typeof item]);

    total += (value as number) || 0;
  });

  return total;
}

export function ensureMaxArraySize<Entity = any>(items: Entity[], lengthLimit: number): Entity[][] {
  if (items.length <= lengthLimit) return [items];

  const numberOfSubArrays = Math.ceil(items.length / lengthLimit);

  const subArrays = Array.from({ length: numberOfSubArrays }).map((_, index) => {
    const start = index * lengthLimit;
    const end = (index + INDEX_OFFSET) * lengthLimit;

    return items.slice(start, end);
  });

  return subArrays;
}

export function toTruthyList<T>(list: T[]): NonNullable<T>[] {
  return list.filter(Boolean) as NonNullable<T>[];
}

export function toUniqueList<T>(list: T[]): T[] {
  return Array.from(new Set(list));
}

export function ensureArray<E>(item: E | E[]): E[] {
  return Array.isArray(item) ? item : [item];
}

export function atLeastOneFalsy(list: any[]) {
  return list.some((x) => !x);
}

export function arrayFrom<Result>(length: number, mapfn?: (k: number) => Result) {
  return Array.from({ length }, (_, i) => mapfn?.(i));
}
